import Enum from "@rover/shared/js/types/Enum";
export default class FooterTheme extends Enum<string> {
  static LIGHT = new FooterTheme('light');
  static DARK = new FooterTheme('dark');
  static isLocked = true;
}


// WEBPACK FOOTER //
// ../kibble/styles/FooterTheme.ts